<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <!-- <div class="table-page-search-wrapper">
          搜索区域
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入名称查询" v-model="queryParam.supplier"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="手机号码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入手机号码查询" v-model="queryParam.telephone"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="联系电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入联系电话查询" v-model="queryParam.phonenum"></a-input>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">

                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div> -->
        <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin-top: 5px">
          <!-- <a-button type="primary" @click="searchQuery">查询</a-button> -->
          <a-button @click="handleAdd" type="primary" icon="plus">添加</a-button>
        </div>
        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" bordered rowKey="id" :columns="columns" :dataSource="dataSource" :pagination="ipagination" :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,columnWidth:'3%'}" :scroll="{ x: 500 }" :loading="loading" @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a @click="delConfirm(handleDelete,record.id)">删除</a>
            </span>
            <!-- 状态渲染模板 -->
            <template slot="releaseTime" slot-scope="text, record">
              <span>{{record.createTime?changetime(record.createTime):'-'}}</span>
            </template>
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <registerModel ref="modalForm" @ok="modalFormOk" @close="modalFormClose"></registerModel>
        <import-file-modal ref="modalImportForm" @ok="modalFormOk" @close="modalFormClose"></import-file-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<!-- b y 7 5 2 7  1 8 9 2 0 -->
<script>
import registerModel from './modules/registerModel'
import ImportFileModal from '@/components/tools/ImportFileModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JDate from '@/components/jeecg/JDate'
import { certificateDelete } from '@/api/api'
import Vue from 'vue'
export default {
  name: 'VendorList',
  mixins: [JeecgListMixin],
  components: {
    registerModel,
    ImportFileModal,
    JDate,
  },
  data() {
    return {
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 查询条件
      queryParam: {},
      // ipagination: {
      //   pageSizeOptions: ['10', '20', '30', '100', '200'],
      // },
      // 表头
      columns: [
        { title: '注册/备案编号', dataIndex: 'registerNo', width: 70, align: 'left' },
        { title: '注册人/备案名称', dataIndex: 'registerName', width: 70, align: 'left' },
        {
          title: '添加时间',
          dataIndex: 'createTime',
          width: 100,
          align: 'left',
          scopedSlots: { customRender: 'releaseTime' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/unit/listCertificate',
        delete: '/unit/certificateDelete',
        deleteBatch: '/supplier/deleteBatch',
        importExcelUrl: '/supplier/importVendor',
        exportXlsUrl: '/supplier/exportExcel',
        batchSetStatusUrl: '/supplier/batchSetStatus',
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}${this.url.importExcelUrl}`
    },
  },
  created() {},
  methods: {
    changetime(createTime) {
      return createTime.substring(0, 10)
    },
    // 删除
    async handleDelete(id) {
      const res = await certificateDelete({ id })
      console.log(res, 'res')
      if (res.errno == 200 && res.errmsg == '成功') {
        this.$message.success('删除成功')
        this.loadData()
      } else {
        this.$message.error(res.data || res.errmsg)
      }
    },
    searchReset() {
      this.queryParam = {
        // type: '供应商',
      }
      this.loadData(1)
    },
    handleImportXls() {
      let importExcelUrl = this.url.importExcelUrl
      let templateUrl = '/doc/vendor_template.xls'
      let templateName = '供应商Excel模板[下载]'
      this.$refs.modalImportForm.initModal(importExcelUrl, templateUrl, templateName)
      this.$refs.modalImportForm.title = '供应商导入'
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
      this.$refs.modalForm.disableSubmit = false
      if (this.btnEnableList.indexOf(1) === -1) {
        this.$refs.modalForm.isReadOnly = true
      }
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>